import React from 'react';
import Typography from '@mui/material/Typography';
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import { useState, useEffect } from 'react';

export default function SeaQuoteSummary(props) {

    const [quoteDetails, setQuoteDetails] = useState(null);

    useEffect(() => {
        if (props.quoteDetails) {
            setQuoteDetails(props.quoteDetails);
        }
    }, [props]);

    const handleBookingReferenceClick = (shipmentId) => {
        if (shipmentId) {
            return window.location.href = '/LeoSeaPortal/bookingdetails?shipmentId=' + shipmentId + ''
        }
    };

    const getDeliveryAddress = (addresses) => {
        var delAddress = addresses.find((address) => {
            return address.addressUseCode === 'DEL';
        })
        if (delAddress) {
            return `${delAddress.organisationName}\n 
                    ${delAddress.locality}\n 
                    ${delAddress.countyState}\n 
                    ${delAddress.postcode}\n 
                    ${delAddress.countryName.toUpperCase()}\n`
        }
        
        return "";
    };

    const getShipperAddress = (addresses) => {
        var delAddress = addresses.find((address) => {
            return address.addressUseCode === 'SHP';
        })
        if (delAddress) {
            return `${delAddress.organisationName}`
        }

        return "";
    };

    const getConsigneeAddress = (addresses) => {
        var delAddress = addresses.find((address) => {
            return address.addressUseCode === 'CNE';
        })
        if (delAddress) {
            return `${delAddress.organisationName}`
        }

        return "";
    };

    if (quoteDetails) {
    return (
        <>
            <GridContainer>
                <GridItem xs={3}>
                    <Typography fontWeight={700}>Europa Reference</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {quoteDetails.shipmentRef}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Quote Valid To Date</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {quoteDetails.shipmentQuote.validToDate}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Shipper</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {getShipperAddress(quoteDetails.addresses)}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Consignee</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {getConsigneeAddress(quoteDetails.addresses)}
                    </Typography>
                </GridItem>
            </GridContainer>

            <GridContainer>
                <GridItem xs={3}>
                    <Typography fontWeight={700}>Delivery Address</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {getDeliveryAddress(quoteDetails.addresses)}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Port of Loading</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {quoteDetails.sourceTerminalLabel}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Port of Discharge</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {quoteDetails.destinationTerminalLabel}
                    </Typography>
                </GridItem>
            </GridContainer>

            <GridContainer>
                <GridItem xs={3}>
                    <Typography fontWeight={700}>Cargo Mode</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {quoteDetails.cargoMode}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Term Type</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {quoteDetails.termTypeCode}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Total Cost &pound; *</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {quoteDetails.shipmentQuote.totalCharge}
                    </Typography>
                </GridItem>

                {quoteDetails.webPortalAssociatedShipment && 
                    <GridItem xs={3}>
                        <Typography fontWeight={700}>Booking Reference</Typography>
                        <Typography onClick={() => handleBookingReferenceClick(quoteDetails.webPortalAssociatedShipment.shipmentId)} style={{ cursor: 'pointer' }} variant="body2" color="text.secondary">
                            <u>{quoteDetails.webPortalAssociatedShipment.shipmentRef}</u>
                        </Typography>
                    </GridItem>
                }
            </GridContainer>
        </>
    );
            } else {
                return <span>Loading...</span>
            }
}

